module.exports = __webpack_public_path__ + "img/GCASH.8adad476.png";